import { grey } from '@mui/material/colors';
import palette from '../theme/fingo/palette';

export const COMPLIANCE_STATUS = {
  FINISHED: 'FINISHED',
  PROCESSING: 'PROCESSING',
  STARTED: 'STARTED',
  REJECTED: 'REJECTED',
  EXPIRED: 'EXPIRED',
};

export const ITAU_COMPLIANCE_STATUS_COLORS = {
  [COMPLIANCE_STATUS.FINISHED]: palette.success.main,
  [COMPLIANCE_STATUS.STARTED]: palette.warning.A300,
  [COMPLIANCE_STATUS.EXPIRED]: palette.error.A600,
};

export const ITAU_COMPLIANCE_STATUS_TEXT = {
  [COMPLIANCE_STATUS.FINISHED]: 'Aprobado',
  [COMPLIANCE_STATUS.STARTED]: 'Pendiente',
  [COMPLIANCE_STATUS.EXPIRED]: 'Expirado',
};

export const COMPLIANCE_NO_INFORMATION_COLOR = grey.A400;
